import React, { useContext } from 'react';
import { useVideoConfig, AbsoluteFill, Img, staticFile  } from "remotion";
import QueryStringContext from '../../components/QueryStringContext';
import '../../App.css';
import { loadFont } from "@remotion/google-fonts/Handlee";


export const MyThumbnail = () => {
  const { fps, durationInFrames, width, height } = useVideoConfig();
  const { f, l } = useContext(QueryStringContext);
  const { fontFamily } = loadFont();

  let cardText;


  if (f == 'null' || f == 'undefined' || f == '') {
    cardText = 'The Desert North Opportunity';
  } else {
    cardText = `${f}'s Desert North Opportunity!`;
  }

  return (
    <>
    <AbsoluteFill>
      <Img src={staticFile('Recruiting_Thumbnail.jpg')} />
    </AbsoluteFill>
    <AbsoluteFill
      style={{
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        backgroundColor: "transparent",
        marginLeft: "0",
        marginRight: "0",
        maxInlineSize: "100%",
        transform: `scale(0.5) translateX(-380px) rotate(4.5deg)`,
        fontFamily: fontFamily,
      }}
    >
      
      <span 
        className='auto-scale-text-xlg color-secondary'
        style={{ transform:"scale(.75)", 
        fontWeight: 400,
        }}
        >
          Why did I choose to design a business that isn't profitable?
      </span>
      <span 
        className='auto-scale-text-xlg color-primary'
        style={{ 
            transform:"scale(.85)",

            
          }}
         
        
        >
         <div 
          style={{
            marginTop: ".25em",
            marginBottom: ".25em",
            fontWeight: 900,
            }}>
           {cardText}
          </div>
          <div 
          style={{
            marginTop: "-.25em"
            }}>
          
          </div>
      </span>
      
    </AbsoluteFill>

    </>
  );
};



